import * as React from 'react';
import * as ReactDOM from 'react-dom';
import CalendarSharingPermissionsModalRenderer from './CalendarSharingPermissionsModalRenderer';
import ColoredBulletOption from './ColoredBulletOption';
import getStore from '../data/store/store';
import SharedCalendarViewState from '../data/store/schema/SharedCalendarViewState';
import strings from 'owa-strings/owa-options-strings';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { observer } from 'mobx-react';
import { showCalendarSharingPermissionsDialog } from 'owa-calendar-sharing/lib/actions/calendarSharing';
import 'owa-calendar-sharing/lib/orchestrators/loadCalendarSharePermissionsOrchestrator';
const styles = require('./ShareACalendarSection.scss');
const CALENDAR_SHARING_TIME_DELAY = 0;

/**
 * Dropdown index set to -1 so that dropdown selection does not change
 * The dropdown is an entry point for calendar sharing dialog and not used for selecting any property value.
 */
const SELECTED_CALENDAR_INDEX = -1;

/**
 * This renders the dropdown entry point for Calendar sharing dialog box
 */
export default observer(function ShareACalendarSection() {
    let { calendars } = getStore();

    return (
        <div className={styles.shareACalendarWrapper}>
            <div className={styles.shareACalendarSectionMessage}>
                {strings.options_sharedCalendars_ShareCalendarSectionMessage}
            </div>
            <Dropdown
                className={styles.dropdownContainer}
                placeHolder={strings.options_sharedCalendars_SelectCalendarLabel}
                selectedKey={SELECTED_CALENDAR_INDEX}
                calloutProps={{
                    className: styles.shareACalendarCallout,
                }}
                onRenderOption={onRenderOption}
                onChanged={(item: IDropdownOption) => {
                    let calendar: SharedCalendarViewState = calendars[item.key];
                    // Added setTimeout with zero delay to avoid the JS error for maximum call stack exceeded
                    // when two modal box get displayed on top of each other while dropdown closes.
                    setTimeout(
                        () =>
                            show(
                                calendar.folderId,
                                '',
                                calendar.hexColorString,
                                calendar.calendarName
                            ),
                        CALENDAR_SHARING_TIME_DELAY
                    );
                }}
                options={getCalendarOptions(calendars)}
            />
        </div>
    );
});

let containerDiv = null;

/**
 * Function to render the Calendar sharing permission modal wrapper
 */
function show(folderId: string, calendarId: string, calendarColor: string, calendarName: string) {
    showCalendarSharingPermissionsDialog(folderId, calendarId, calendarColor, calendarName);
    close(); // close if it is already showing
    containerDiv = document.createElement('div');
    containerDiv.id = 'calendarSharingDialog';
    document.body.appendChild(containerDiv);
    ReactDOM.render(<CalendarSharingPermissionsModalRenderer />, containerDiv);
}

/**
 *  Function to remove the calendar sharing modal renderer from DOM
 */
function close() {
    if (containerDiv) {
        ReactDOM.unmountComponentAtNode(containerDiv);
        document.body.removeChild(containerDiv);
        containerDiv = null;
    }
}

const getCalendarOptions = (calendars: SharedCalendarViewState[]) => {
    let calendarsToShare = calendars.map((sharedCalendar, index) => {
        return {
            key: index,
            text: sharedCalendar.calendarName,
            canShare: sharedCalendar.canShare,
            data: {
                color: sharedCalendar.hexColorString,
            },
        };
    });
    return calendarsToShare.filter(calendar => {
        return calendar.canShare;
    });
};

/**
 * Custom renderer for dropdown as a colored bullet needs to be shown
 */
const onRenderOption = (option: IDropdownOption): JSX.Element => {
    return <ColoredBulletOption color={option.data.color} label={option.text} />;
};
